import React, {Component} from 'react';

import ComponentHeader from "./componentHeader";
import { Row } from 'simple-flexbox';

import '../assets/css/apiData.css';

class EmptyScreen extends Component {
  state = {};

  componentDidMount() {
    this.props.history.push(`/generate-reports`);
  };

  render() {
    return (
      <Row flexGrow={ 1 } className='module apidata' vertical='start'>
        <ComponentHeader />
      </Row>
    );
  }
}

export default EmptyScreen;
